export default __webpack_public_path__ + "static/media/MATH_OPERATION_SYMBOLS.e8c0e342.svg";